import api from './client';
import type {
  CreateSkillDto,
  LicenseSkillAssignment,
  UpdateSkillDto,
} from '@/types/domain';
import {
  mapLicenseSkillListPayload,
  mapSkillListPayload,
} from './skills.mapper';

export const skillsAPI = {
  getAll: async () => {
    const response = await api.get('/api/admin/skills');
    const skills = mapSkillListPayload(response.data);
    return {
      ...response.data,
      data: skills,
      skills,
    };
  },

  getById: async (id: string) => {
    const response = await api.get(`/api/admin/skills/${id}`);
    return response.data;
  },

  create: async (data: CreateSkillDto) => {
    const response = await api.post('/api/admin/skills', data);
    return response.data;
  },

  update: async (id: string, data: UpdateSkillDto) => {
    const response = await api.put(`/api/admin/skills/${id}`, data);
    return response.data;
  },

  delete: async (id: string) => {
    const response = await api.delete(`/api/admin/skills/${id}`);
    return response.data;
  },

  toggle: async (id: string, isActive: boolean) => {
    const response = await api.post(`/api/admin/skills/${id}/toggle`, { isActive });
    return response.data;
  },

  getLicenseSkills: async (licenseKey: string) => {
    const response = await api.get(`/api/admin/license-keys/${licenseKey}/skills`);
    const data: LicenseSkillAssignment[] = mapLicenseSkillListPayload(response.data);
    return { ...response.data, data };
  },

  updateLicenseSkills: async (licenseKey: string, skillIds: string[]) => {
    const response = await api.post(`/api/admin/license-keys/${licenseKey}/skills`, { skillIds });
    return response.data;
  },

  toggleLicenseSkill: async (licenseKey: string, skillId: string) => {
    const response = await api.put(`/api/admin/license-keys/${licenseKey}/skills/${skillId}`);
    return response.data;
  },
};
